"use strict";
exports.__esModule = true;
var LoginType;
(function (LoginType) {
    LoginType["LEGACY_LOGIN"] = "LEGACY_LOGIN";
    LoginType["CHECKOUT_LOGIN"] = "CHECKOUT_LOGIN";
    LoginType["LOGIN_NOT_REQUIRED"] = "LOGIN_NOT_REQUIRED";
    LoginType["TWO_FA_REQUIRED"] = "TWO_FA_REQUIRED";
})(LoginType = exports.LoginType || (exports.LoginType = {}));
